import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, MaskLines } from "./Reveal";
import { CtaButton } from "./CtaButton";
import { IMAGES } from "@/constants/images";

export const FinalCTA = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section ref={ref} className="relative flex min-h-[90svh] items-center overflow-hidden border-t border-white/10">
      <motion.div style={{ y }} className="absolute inset-0 -z-10 scale-110">
        <img
          src={IMAGES.finalCta}
          alt="Shabz Fazl"
          className="h-full w-full object-cover object-center opacity-40 grayscale-[0.2]"
        />
      </motion.div>
      <div className="absolute inset-0 -z-10 bg-gradient-to-t from-[#0a0a0b] via-[#0a0a0b]/85 to-[#0a0a0b]/60" />
      <div
        className="pointer-events-none absolute -bottom-32 left-1/2 h-[60vh] w-[60vh] -translate-x-1/2 rounded-full opacity-20 blur-3xl"
        style={{ background: "radial-gradient(circle, #d4af37, transparent 65%)" }}
      />

      <div className="mx-auto w-full max-w-7xl px-6 py-28 sm:px-8 lg:px-12">
        <Reveal>
          <span className="font-['IBM_Plex_Mono'] text-[11px] uppercase tracking-[0.3em] text-[#d4af37]">
            The Next Move Is Yours
          </span>
        </Reveal>
        <h2 className="mt-8 max-w-4xl font-['Playfair_Display'] text-4xl font-semibold leading-[1.02] tracking-tight sm:text-6xl lg:text-7xl">
          <MaskLines
            whileInView
            lineClass="text-white-gold"
            lines={["Stop trading against", "the same wall.", "Break through it."]}
          />
        </h2>
        <Reveal delay={0.2} className="mt-9 max-w-xl">
          <p className="text-base leading-relaxed text-[#c9c9c2] sm:text-lg">
            If you&rsquo;re a six-figure trader who&rsquo;s serious about the next level, there&rsquo;s
            one way in. Message Shabz on Instagram &mdash; no forms, no calls, just a direct
            conversation about whether you&rsquo;re ready.
          </p>
        </Reveal>
        <Reveal delay={0.35} className="mt-11">
          <CtaButton testid="final-cta" className="px-10 py-5 text-base" />
        </Reveal>
      </div>
    </section>
  );
};
